<script setup>
import Icon from '@/components/shared/icons/Icon.vue'
import {componentColors} from '@/constants/components.js'

//Emits and props
defineProps({
  text: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  isIconOutlined: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: '',
    validator(value) {
      if (value === '') {
        return true
      }
      return [
        componentColors.SUCCESS,
        componentColors.WARNING,
        componentColors.DANGER,
        componentColors.INFO,
        componentColors.MUTED,
      ].includes(value)
    },
  },
})
</script>

<template>
  <div
    :class="{
      [$style.badge]: true,
      [$style[color]]: !!color,
    }"
  >
    <Icon
      v-if="icon"
      :icon="icon"
      :is-outlined="isIconOutlined"
      :color="color"
      size="xs"
    />
    <slot>{{ text }}</slot>
  </div>
</template>

<style module lang="scss">
.badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 2rem;
  background-color: var(--bg-badge-default);
  color: var(--color-text);
  font-size: var(--font-size-s);
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
  &.muted {
    background-color: var(--bg-badge-muted);
  }
  &.danger {
    background-color: var(--bg-badge-danger);
    color: var(--color-text-danger);
  }
  &.warning {
    background-color: var(--bg-badge-warning);
    color: var(--color-text-warning);
  }
  &.success {
    background-color: var(--bg-badge-success);
    color: var(--color-text-success);
  }
  &.info {
    background-color: var(--bg-badge-info);
    color: var(--color-text-info);
  }
}
</style>
